import React, { useCallback } from 'react'
import { TStepProps } from '@health-zelas/quiz'
import { RichText } from 'prismic-reactjs'
import { useEffect, useState } from 'react'
import Step from '../../components/Step'
import { Card, Image, Paragraph, Button, Container } from '@health-zelas/delta'
import ProgressBar from '../../components/ProgressBar'

import * as S from './DentalPlan.styles'

interface PrismicResponse {
  results?: Record<string, any>[]
}

export const DentalPlan = ({ navigateToPrevStep } : TStepProps )  => {
  const [odontoPlanPage, setOdontoPlanPage] = useState<PrismicResponse>({})
  const [ ref, setRef ] = useState('base_ref')

  async function getRepoRef() {
    try{
      fetch('https://tudo-saude-escale.prismic.io/api/v2/')
      .then(response => response.json())
      .then(response => {
        setRef(response.refs?.[0]?.ref)
      })
    } catch(e) {
      console.log('error: ', e)
    }
  }

  const getOdontoPages = useCallback(async () => {
    if(ref !== 'base_ref'){
      try{
        fetch(`https://tudo-saude-escale.prismic.io/api/v2/documents/search?ref=${ref}&q=[[at(my.odonto_plan.uid,"odonto-plan-quiz")]]`)
        .then((response) => response.json())
        .then((response) => {
          setOdontoPlanPage(response)
        })
      } catch(e){
        console.log('error: ', e)
      }
    }
  }, [ref])

  useEffect(() => {
    getRepoRef()
  }, [])


  useEffect(() => {
    getOdontoPages()
  }, [ref, getOdontoPages])

  const operators = odontoPlanPage?.results?.[0]?.data?.operators
  const operatorFilled = operators?.length > 0
  return (
    <Step isLastStep>
      <Container>
        <S.Wrapper>
          <ProgressBar title="Resultado" fill={4} lastStep="Concluído" />
            <Paragraph
              as='div'
              css={{
                marginBottom: '1.5rem',
                h1: {
                  fontSize: '2rem',
                  fontWeight: 'bold',
                },
                strong: {
                  color: '#4d4d4d',
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  fontSize: '1.25rem',
                },
            }}>
            <RichText render={odontoPlanPage?.results?.[0]?.data?.content} />
            </Paragraph>
            <div id='odonto-plan' style={{ marginBottom: '2rem' }}>
            <Container css={{
                display: 'flex',
                gap: '1rem',
                padding: 0,
                flexDirection: 'column',
                '@sm': {
                  flexDirection: 'row'
                }
              }}>
              {
                operatorFilled &&
                (
                  operators.map((operator: Record<string, any>) => {
                  const{image, link} = operator
                  return (
                    <Card
                      as='a'
                      // @ts-expect-error: Card will have HREF prop when defined as <a>
                      href={link ?? ''}
                      key={image.alt}
                      target='_blank'
                      rel='noopener noreferrer'
                      id={`odonto-plan-${image.alt}`}
                      css={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        padding: 40,
                        marginBottom: '1.5rem',
                        img: {
                          maxWidth: '100%',
                          height: 'auto'
                        }
                      }}
                    >
                      <Image
                        src={image.url}
                        alt={image.alt}
                        css={{
                          marginBottom: '1.5rem',
                        }}
                      />
                      <Button
                        css={{
                        fontWeight: 600,
                        }}
                        fullWidth
                        type='button'
                      >
                        Conhecer os planos
                      </Button >
                    </Card>
                  )
                }
              ))
              }
            </Container>
            <Paragraph
              as='div'
              css={{
                  marginBottom: '1.5rem',
                  h1: {
                    fontSize: '2rem',
                    fontWeight: 'bold',
                },
                strong: {
                  color: '#4d4d4d',
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  fontSize: '1.25rem',
                },
            }}>
            <RichText render={odontoPlanPage?.results?.[0]?.data?.helperText} />
            </Paragraph>
          </div>
          <S.ButtonGroup>
                <Button
                  variant="tertiary"
                  size="large"
                  id="voltar_dados"
                  onClick={navigateToPrevStep}
                >
                  Voltar
                </Button>
              </S.ButtonGroup>
          </S.Wrapper>
      </Container>
    </Step>
  )
}
